/* tslint:disable */
/* eslint-disable */
/**
 * Atelier Roles API
 * L\'Atelier des rôles (BO admin) : référentiel des briques (standard verrouillées, personnalisées administrables), profils (ensembles de rôles appliqués à la création des acteurs) et matrice rôles/portails. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionItemDto } from './PermissionItemDto';
import {
    PermissionItemDtoFromJSON,
    PermissionItemDtoFromJSONTyped,
    PermissionItemDtoToJSON,
    PermissionItemDtoToJSONTyped,
} from './PermissionItemDto';

/**
 * 
 * @export
 * @interface PermissionGroupeDto
 */
export interface PermissionGroupeDto {
    /**
     * 
     * @type {string}
     * @memberof PermissionGroupeDto
     */
    nom: string;
    /**
     * 
     * @type {string}
     * @memberof PermissionGroupeDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {Array<PermissionItemDto>}
     * @memberof PermissionGroupeDto
     */
    permissions: Array<PermissionItemDto>;
}

/**
 * Check if a given object implements the PermissionGroupeDto interface.
 */
export function instanceOfPermissionGroupeDto(value: object): value is PermissionGroupeDto {
    if (!('nom' in value) || value['nom'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function PermissionGroupeDtoFromJSON(json: any): PermissionGroupeDto {
    return PermissionGroupeDtoFromJSONTyped(json, false);
}

export function PermissionGroupeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionGroupeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'nom': json['nom'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'permissions': ((json['permissions'] as Array<any>).map(PermissionItemDtoFromJSON)),
    };
}

export function PermissionGroupeDtoToJSON(json: any): PermissionGroupeDto {
    return PermissionGroupeDtoToJSONTyped(json, false);
}

export function PermissionGroupeDtoToJSONTyped(value?: PermissionGroupeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nom': value['nom'],
        'libelle': value['libelle'],
        'permissions': ((value['permissions'] as Array<any>).map(PermissionItemDtoToJSON)),
    };
}

